export const CUR = { nzd: "NZ$", usd: "US$", aud: "A$", gbp: "£", eur: "€", cad: "C$" };

export const money = (amt, cur) => `${CUR[cur] || "$"}${Number(amt || 0).toFixed(2)}`;

export const CURRENCY_OPTIONS = [
  { code: "nzd", label: "NZ$ · New Zealand Dollar" },
  { code: "usd", label: "US$ · US Dollar" },
  { code: "aud", label: "A$ · Australian Dollar" },
  { code: "gbp", label: "£ · British Pound" },
  { code: "eur", label: "€ · Euro" },
  { code: "cad", label: "C$ · Canadian Dollar" },
];
